import React, { useEffect, useState } from "react";

import { Box, Card, CardContent, CircularProgress, Grid2, Stack, Typography } from "@mui/material";
import theme from "../../../theme/Theme";
import { Link, useParams } from "react-router-dom";
import { NoRecordFound } from "../../../assets";
import { fetchUserList } from "../../../api/ApiService";
import CustomButton from "../../../component/CustomButton";
import DashboardPageTitle from "../../../component/DashboardPageTitle";
import DashboardLoader from "../../../component/DashboardLoader";


const UserDetails = () => {
    const { fullName } = useParams();
    const [usersList, setUsersList] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {

            try {
                const response = await fetchUserList();
                if (response && response.data) {
                    const data = response.data.find((d) => d.fullName === fullName);
                    setUsersList(data);
                }
            } catch (error) {
                console.error("Error fetching draws data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [fullName]);
    if (loading) {
        return (
            <Box sx={styles.loadingContainer}>
                <DashboardLoader />
            </Box>
        );
    }
    if (!usersList) {
        return (
            <Stack direction={"column"} alignItems={"center"} gap={1}>
                <Box
                    component={"img"}
                    src={NoRecordFound}
                    sx={{ width: "300px", height: "300px" }}
                />
                <Typography sx={styles.noDataContainer}>
                    No Users Found
                </Typography>
            </Stack>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
           <DashboardPageTitle title={"User Details"} />
            <Box sx={styles.cardContainer}>
                <Card sx={styles.card}>
                    <CardContent>
                        <Typography variant="subtitle1" sx={styles.detailLabel}>
                            User Name
                        </Typography>
                        <Typography variant="body1" sx={styles.detailValue}>

                            {usersList.fullName}
                        </Typography>
                        <Typography variant="subtitle1" sx={styles.detailLabel}>
                            User Email
                        </Typography>
                        <Typography variant="body1" sx={styles.detailValue}>
                            {usersList.emailAddress}
                        </Typography>
                        <Typography variant="subtitle1" sx={styles.detailLabel}>
                            Ticket Purchase
                        </Typography>
                        <Typography variant="body1" sx={styles.detailValue}>
                            {usersList.totalTicketPurchase}
                        </Typography>
                        <Typography variant="subtitle1" sx={styles.detailLabel}>
                            User Public Address
                        </Typography>
                        <Typography variant="body1" sx={styles.detailValue}>
                            {usersList.publicAddress}
                        </Typography>
                        <Grid2 item size={{ xs: 6, md: 3 }} sx={{ display: "flex", mt: 4 }}>
                        <CustomButton
                                title={"Back to Users List"}
                               
                                onClick={() => window.history.back()}
                            />
                        </Grid2>
                          
                        
                    </CardContent>
                </Card>
            </Box>
        </Box>
    )
}

export default UserDetails;
const styles = {
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "3em",
        my: 15,
    },
    noDataContainer: {
        color: "#525252",
        fontSize: "1rem",
        fontWeight: 500,
        textAlign: "center",
        padding: "1em 0",
    },
    cardContainer: {
        display: "flex",
        justifyContent: "left",
        marginTop: "2em",
    },
    card: {
        maxWidth: 500,
    },
    detailLabel: {
        color: theme.palette.text.secondary,
        fontWeight: 500,
        fontSize: "1.2rem",

    },
    detailValue: {
        color: theme.palette.text.primary,
        fontWeight: 500, // Adjusted font weight
        fontSize: "1rem", // Decreased font size
        marginBottom: theme.spacing(2),
    },
};